module.exports = __webpack_public_path__ + "img/horse-tips-redirect.a529fa9e.svg";